import React from "react";
import { useLanguage } from "../LanguageContext";
import { mailtoWithSubject } from "../utils/mailto";

const Hero: React.FC = () => {
    const { t } = useLanguage();
    const h = t.hero;
    return (
        <section className="hero" id="top">
            <div className="hero-bg">
                <div className="hero-grid" />
                <div className="hero-orb hero-orb-1" />
                <div className="hero-orb hero-orb-2" />
            </div>

            <div className="hero-content">
                <div className="hero-label">{h.label}</div>

                <h1 className="hero-title">
                    <span className="hero-title-line">{h.titleLine1}</span>
                    <span className="hero-title-line hero-title-accent">{h.titleLine2}</span>
                </h1>

                <p className="hero-tagline">{h.tagline}</p>

                <div className="hero-actions">
                    <a className="btn-primary" href={mailtoWithSubject(t.mail.consultation)}>{h.cta1}</a>
                    <a href="#services" className="btn-ghost">{h.cta2}</a>
                </div>

                <div className="hero-rule" />
            </div>

            <div className="hero-scroll">
                <div className="scroll-line" />
            </div>
        </section>
    );
};

export default Hero;
